
export const certifications: string[] = [
  'Al Sa\'fat',
  'Aquaculture Stewardship Council (ASC)',
  'Audubon G.U.L.F RFM',
  'BCA Green Mark',
  'BEAM Plus',
  'BEAM Plus Neighbourhood',
  'BEAM Plus Selective',
  'BER',
  'Best Aquaculture Practices (BAP)',
  'Best Seafood Practices (BSP)',
  'Better Cotton',
  'Bonsucro',
  'Bord Iascaigh Mhara (BIM) Certified Quality Aquaculture Programme (BIM CQA)',
  'BREEAM',
  'CASBEE',
  'CBI-approved proxy',
  'Certified Seafood Collaborative\'s Responsible Fisheries Management (CFC RFM)',
  'China Forest Certification Scheme',
  'China Three Star System',
  'Cotton made in Africa (CmiA)',
  'DBJ Green Building',
  'DGNB',
  'EarthCheck',
  'EDGE',
  'EEWH',
  'EPC',
  'Estidama',
  'FSC',
  'Global G.A.P',
  'Global Organic Textile Standard (GOTS)',
  'Global Sustainability Assessment System – Design and Build',
  'Global Sustainability Assessment System – Operations',
  'Green Buildings Index',
  'Green Star',
  'GreenRE',
  'GREENSHIP',
  'GRIHA',
  'G-SEED',
  'Higg FEM',
  'HQM',
  'IGBC Existing Buildings',
  'IGBC Green Home',
  'IGBC New Buildings',
  'LEED',
  'Living Building Challenge',
  'Minergie',
  'MyCREST',
  'NABERS Energy',
  'PassivHaus',
  'PEFC',
  'SS 564 (Data Centres)',
  'USDA Organic',
  'Vietnam GBC Lotus'
];
